@if (showBajaForm()) {
    <app-request-unsubscribe
        [partyData]="data()"
        [partyForm]="partyForm"
        [vehicles]="vehicleData"
        [selectedVehicleUuid]="selectedBajaVehicleUuid()"
        [currentEntityCode]="data()?.entityCode || entity?.code"
        [processSlug]="selectedProcess || 'UNSUBSCRIBE_VOLUNTARY'"
        [unsubscribeScope]="unsubscribeScope()"
        (onClose)="closeBajaForm()"
        (onSubmitted)="onBajaSubmitted()">
    </app-request-unsubscribe>
}
@else if (showTransferForm()) {
    <app-request-transfer-create
        [partyData]="data()"
        [partyForm]="partyForm"
        [currentEntityCode]="data()?.entityCode || entity?.code"
        [processSlug]="selectedProcess || 'TRANSFER'"
        (onClose)="closeTransferForm()"
        (onSubmitted)="onTransferSubmitted()">
    </app-request-transfer-create>
}
@else if (showViewUnsubscribe()) {
    <app-request-unsubscribe
        [partyData]="data()"
        [partyForm]="partyForm"
        [vehicles]="vehicleData"
        [selectedVehicleUuid]="selectedBajaRequest()?.vehicle?.uuid || selectedBajaRequest()?.referenceUuid"
        [currentEntityCode]="data()?.entityCode || entity?.code"
        [mode]="formMode.VIEW"
        [requestData]="selectedBajaRequest()"
        (onClose)="closeBajaForm()"
        (onSubmitted)="loadRecentRequests(data().uuid)">
    </app-request-unsubscribe>
}
@else if (showAddPartyView()) {
    <app-add-party 
        [partyInput]="selectedRequestParty" 
        [vehicleInput]="selectedRequestVehicle" 
        [requestInput]="selectedRequest"
        [mode]="bpmService.isInitialStep(selectedRequest) ? formMode.EDIT : formMode.VIEW"
        (headerEditorActionChange)="onHeaderEditorAction($event)"
        (onClose)="closeAddPartyView()">
    </app-add-party>
}
@else if (showAddVehicleView()) {
    <app-add-vehicle 
        [partyInput]="data()" 
        (cancel)="showAddVehicleView.set(false); onVehicleAdded()">
    </app-add-vehicle>
}
@else if (showAddBenefit()) {
    <app-add-benefit
        [partyInput]="data()"
        [vehiclesInput]="(vehicleData?.length ? vehicleData : vehicleHistoryData) || []"
        (onClose)="closeAddBenefit()"
        (benefitAdded)="onBenefitAdded()">
    </app-add-benefit>
}
@else if (!showAddClaim()) {
<div class="row">
    <div class="col-12">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a [href]="'#general'" data-bs-toggle="tab" (click)="tabSelected = 1" class="nav-link"
                    [class.active]="tabSelected ==1">Datos Generales</a>
            </li>
            <li class="nav-item">
                <a [href]="'#documents'" data-bs-toggle="tab" (click)="tabSelected = 2" class="nav-link"
                    [class.active]="tabSelected ==2">Documentos</a>
            </li>
        </ul>
    </div>
</div>

@if(tabSelected==1){
<div class="tab-content panel" [class.p-4]="!appSettings.isMobile()" [class.p-3]="appSettings.isMobile()" [ngClass]="{ 'show active rounded-0 rounded-bottom': tabSelected>0 }">
    <div class="tab-pane fade" [ngClass]="{ 'show active ': tabSelected==1 }" id="general">
        <div class="panel-body">
            <app-party-form [partyForm]="partyForm" (formChange)="submitParty()" (modeChange)="onModeChange($event)"
                [mode]="mode">
                <div class="d-flex justify-content-end align-items-center">
                    @if(isDraft()){
                        
                    } @else if(isActive()){
                        @if(mode == formMode.EDIT){
                        <button class="btn btn-primary btn-sm" (click)="submitParty()"><i class="fa fa-save"></i>
                            Actualizar</button>
                        <button class="btn btn-outline-secondary btn-sm ms-2" (click)="onModeChange(formMode.VIEW)"><i
                                class="fa fa-times"></i> Cancelar</button>
                        }
                        @if(mode == formMode.VIEW){
                            @if(perm.canCurrent('canUpdate')){
                            <button class="btn btn-outline-primary btn-sm" (click)="onModeChange(formMode.EDIT)"><i
                                    class="fa fa-edit"></i> Editar</button>
                            }
                            @if(vehicleData?.length > 0){
                                @if(perm.hasCurrentAction('UNSUBSCRIBE_PARTY')){
                                <button class="btn btn-outline-danger btn-sm ms-2"
                                    (click)="openUnsubscribeParty()">
                                    <i class="fa-solid fa-user-minus me-1"></i> Baja Socio
                                </button>
                                }
                                @if(perm.hasCurrentAction('UNSUBSCRIBE_ADM')){
                                <button class="btn btn-outline-danger btn-sm ms-2"
                                    (click)="openUnsubscribeAdmin()">
                                    <i class="fa-solid fa-user-xmark me-1"></i> Baja Admin
                                </button>
                                }
                                @if(perm.hasCurrentAction('BENEFIT_CREATE')){
                                <button type="button" class="btn btn-outline-primary btn-sm ms-2" (click)="openAddBenefitModal()">
                                    <i class="fa-solid fa-hand-holding-heart me-1"></i> Beneficio
                                </button>
                                }
                                @if(perm.hasCurrentAction('CLAIM_CREATE')){
                                <button type="button" class="btn btn-outline-warning btn-sm ms-2" (click)="openAddClaimModal()">
                                    <i class="fa-solid fa-car-crash me-1"></i> Siniestro
                                </button>
                                }
                                @if(perm.hasCurrentAction('VEHICLE_FULL_EDIT')){
                                <button type="button" class="btn btn-outline-secondary btn-sm ms-2" (click)="openVehicleFullFromHeader()">
                                    <i class="fa-solid fa-car-side me-1"></i> Solicitud Vehículo
                                </button>
                                }
                            }
                            @if(perm.hasCurrentAction('TRANSFER_CREATE')){
                            <button class="btn btn-outline-secondary btn-sm ms-2" (click)="openRequestModal('TRANSFER')" 
                                [class.btn-outline-info]="pendingTransfer()" >
                                <i class="fa fa-exchange me-1"></i> 
                                {{ pendingTransfer() ? 'Transferencia en Trámite' : 'Transferir' }}
                            </button>
                            }
                        }
                    } @else if(data().statusSlug==='INACTIVE'){
                        @if(perm.canCurrent('canUpdate')){
                        <button class="btn btn-outline-secondary btn-sm ms-2" (click)="updateStatus(data(),'ACTIVE')"><i
                            class="fa fa-check"></i> Activar</button>
                        }
                    }
                </div>
            </app-party-form>
           
        </div>
    </div>
</div>
}

@if(tabSelected==1){
<div class="row">
    <div class="col-xl-12">
        @if (appSettings.isMobile()) {
        <div class="d-flex align-items-center justify-content-between my-2 px-1">
            <span class="fw-bold text-dark text-uppercase small">
                <i class="fas fa-car text-primary me-2"></i>Protecciones
            </span>
            @if (perm.hasCurrentAction('VEHICLE_CREATE') && isActive()) {
                <button type="button" class="btn btn-outline-primary btn-xs" (click)="openAddVehicleModal()">
                    <i class="fas fa-plus me-1"></i>Nuevo
                </button>
            }
        </div>
        @if (vehicleData?.length > 0) {
            @for (vehicle of vehicleData; track vehicle.uuid || vehicle.id) {
                <app-list-card
                   
                    (click)="perm.hasCurrentAction('VEHICLE_QUICK_EDIT') && isActive() && openModal(vehicle, 'quick')">
                    <div cardTitle class="fw-bold text-dark text-truncate">
                        {{ vehicle.plate }}
                    </div>
                    <div class="text-muted small">
                        {{ vehicle.brandName }} {{ vehicle.modelName }} {{ vehicle.year }}
                    </div>
                    <div class="text-muted small mt-1">
                        Valor: ${{ vehicle.commercialValue | number:'1.0-0':'es-CL' }}
                    </div>
                    <span cardExtra class="text-uppercase fw-semibold text-muted" style="font-size: 0.75rem; letter-spacing: 0.5px;">
                        ESTADO
                    </span>
                    <div cardAmount>
                        <span class="badge border" [ngClass]="vehicle.status?.style">{{ vehicle.statusName }}</span>
                    </div>
                </app-list-card>
            }
        } @else {
            <div class="card border-0 shadow-sm p-4 text-center my-2 text-muted">
                @if (vehicleHistoryData.length > 0) {
                    No hay vehículos activos
                } @else {
                    No hay vehículos registrados
                }
            </div>
        }

        <div class="d-flex align-items-center justify-content-between my-3 px-1">
            <span class="fw-bold text-dark text-uppercase small">
                <i class="fas fa-clipboard-list text-primary me-2"></i>Últimas solicitudes
            </span>
        </div>
        @if (recentRequests().length > 0) {
            @for (req of recentRequests(); track req.uuid) {
                <app-list-card
                    [isShortcut]="true"
                    (click)="openRecentRequest(req)">
                    <div cardTitle class="fw-bold text-dark text-truncate">
                        {{ req.process?.name }}
                    </div>
                    <div class="text-muted small mt-1">
                        @if (req.targetEntityCode) {
                            {{ req.targetEntityCode }}
                            <span class="mx-1">·</span>
                        }
                        <i class="fa fa-calendar me-1"></i>{{ req.createdAt | date:'dd/MM/yyyy' }}
                    </div>
                    @if (req.reimbursements?.length > 0) {
                        <div class="mt-1 small text-muted text-truncate">
                            Monto: ${{ req.reimbursements[0].amount | number:'1.0-0':'es-CL' }}
                        </div>
                    }
                    <span cardExtra class="text-uppercase fw-semibold text-muted" style="font-size: 0.75rem; letter-spacing: 0.5px;">
                        ESTADO
                    </span>
                    <div cardAmount>
                        <span class="badge border" [ngClass]="req.statusObj?.style">{{ req.statusObj?.name }}</span>
                    </div>
                    @if (bpmService.isUnsubscribeProcess(req.processSlug) && req.statusSlug === 'DRAFT') {
                        <div cardActionsRow>
                            <button type="button" class="btn btn-outline-danger btn-sm w-100"
                                (click)="$event.stopPropagation(); deleteUnsubscribeRequest(req)">
                                <i class="fas fa-trash-alt me-1"></i>Desechar
                            </button>
                        </div>
                    }
                </app-list-card>
            }
        } @else {
            <div class="card border-0 shadow-sm p-4 text-center my-2 text-muted">
                No hay solicitudes recientes
            </div>
        }
        } @else {
        <div class="row align-items-stretch">
            <!--Vehiculos-->
            <div class="col-xl-6 col-md-12">
                <div class="panel h-100">
                    <div class="panel-header p-3 mb-0 bg-none d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <b>Protecciones</b>
                            <span class="ms-2">
                                <i data-bs-toggle="popover" data-bs-trigger="hover" data-bs-title="Protecciones"
                                    data-bs-placement="top" data-bs-content="Información de protecciones"
                                    class="fa fa-info-circle"></i>
                            </span>
                        </div>
                        @if (perm.hasCurrentAction('VEHICLE_CREATE') && isActive()) {
                        <div class="me-2">
                            <div ngbDropdown container="body">
                                <span ngbDropdownToggle ngbTooltip="Acciones" placement="top">
                                    &nbsp;<i class="fas fa-bars"></i>&nbsp;
                                </span>
                                <div ngbDropdownMenu>
                                    <button ngbDropdownItem (click)="openAddVehicleModal()"><i
                                             class="fas fa-plus me-2"></i>Nuevo Vehiculo</button>
                                </div>
                            </div>
                        </div>
                        }
                    </div>

                    <div class="panel-body">
                        <div class="panel-body pt-0 pb-0">
                            <div class="table-responsive table-data mt-2">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th class="text-start ">
                                                <h5> Placa</h5>
                                            </th>
                                            <th class="text-start ">
                                                <h5> Descripción</h5>
                                            </th>
                                            <th class="text-center">
                                                <h5> Estatus</h5>
                                            </th>
                                            <th class="text-end">
                                                <h5> Valor</h5>
                                            </th>
                                            <th class="text-center"><i class="fas fa-cog"></i></th>
                                        </tr>
                                    </thead>
                                    <tbody class="mb-3">
                                        @if(vehicleData?.length > 0){
                                        @for(vehicle of vehicleData; track vehicle.id){
                                        <tr style="height: 35px;">
                                            <td class="text-start align-middle">{{vehicle.plate}}</td>
                                            <td class="text-start align-middle">{{vehicle.brandName}}
                                                 {{vehicle.modelName}} {{vehicle.year}}</td>
                                            <td class="text-center align-middle">
                                                <span class="badge border" [ngClass]="vehicle.status.style">{{
                                                     vehicle.statusName}}
                                                </span>
                                            </td>
                                            <td class="text-end align-middle">${{vehicle.commercialValue| number:'1.0-0':'es-CL'}}</td>
                                            <td class="text-center align-middle">
                                                @if (!isDraft() && (perm.hasCurrentAction('VEHICLE_QUICK_EDIT') || perm.hasCurrentAction('VEHICLE_FULL_EDIT') || perm.hasCurrentAction('UNSUBSCRIBE_PARTY'))) {
                                                <div ngbDropdown container="body">
                                                    <button ngbDropdownToggle type="button"
                                                        class="btn btn-outline-gray btn-xs">
                                                        &nbsp;<i class="fas fa-ellipsis-v"></i>&nbsp;
                                                    </button>
                                                    <div ngbDropdownMenu>
                                                        @if (perm.hasCurrentAction('VEHICLE_QUICK_EDIT')) {
                                                        <button ngbDropdownItem (click)="openModal(vehicle, 'quick')"><i
                                                                 class="fas fa-bolt text-warning me-2"></i>Edición rápida</button>
                                                        }
                                                        @if (perm.hasCurrentAction('VEHICLE_FULL_EDIT')) {
                                                        <button ngbDropdownItem (click)="openModal(vehicle, 'full')"><i
                                                                 class="fas fa-edit text-primary me-2"></i>Solicitud completa</button>
                                                        }
                                                        @if (perm.hasCurrentAction('UNSUBSCRIBE_PARTY')) {
                                                        <button ngbDropdownItem (click)="openUnsubscribeParty(vehicle.uuid);"><i
                                                                 class="fa-solid fa-car text-danger me-2"></i>Dar de baja</button>
                                                        }
                                                    </div>
                                                </div>
                                                }
                                            </td>
                                        </tr>
                                        }
                                        }@else{
                                        <tr>
                                            <td colspan="6" class="text-center">
                                                @if(vehicleData?.length == 0 && vehicleHistoryData.length == 0){
                                                No hay vehículos Registrados
                                                }
                                                @if(vehicleData?.length == 0&&vehicleHistoryData.length > 0){
                                                No hay vehículos Activos
                                                }
                                            </td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div> <!-- Cierra panel resumen -->
            </div>

            <!--Incidencias-->
            <div class="col-xl-6 col-md-12">
                <div class="panel h-100">
                    <div class="panel-header p-3 mb-0 bg-none d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <b>Últimas Solicitudes</b>
                            <span class="ms-2">
                                <i data-bs-toggle="popover" data-bs-trigger="hover" data-bs-title="Solicitudes"
                                    data-bs-placement="top" data-bs-content="Estado de trámites recientes"
                                    class="fa fa-info-circle"></i>
                            </span>
                        </div>
                    </div>

                    <div class="panel-body">
                        <div class="panel-body pt-0 pb-0">
                            <div class="table-responsive table-data mt-2">
                                <table class="table table-sm table-hover">
                                    <thead>
                                        <tr>
                                            <th>
                                                <h5> Trámite</h5>
                                            </th>
                                            <th class="text-center">
                                                <h5> Fecha</h5>
                                            </th>
                                            <th class="text-end">
                                                <h5> Estado</h5>
                                            </th>
                                            <th class="text-end">
                                                <i class="fa fa-cog"></i>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody class="mb-3">
                                        @if(recentRequests().length > 0){
                                        @for(req of recentRequests(); track req.uuid){
                                        <tr>
                                            <td class="text-start">
                                                <span class="d-block fw-bold">{{ req.process?.name }}</span>
                                                <small class="text-muted">{{ req.targetEntityCode }}</small>
                                                @if (req.reimbursements && req.reimbursements.length > 0) {
                                                    <div class="mt-1 d-flex flex-wrap gap-1 align-items-center">
                                                        <small class="text-muted">Monto Aprobado: ${{ req.reimbursements[0].amount | number:'1.0-0':'es-CL' }}</small>
                                                        <span class="badge border" 
                                                            [ngClass]="req.reimbursements[0].statusSlug === 'PAID' ? 'bg-light text-success border-success' : 'bg-light text-warning border-warning'"
                                                            style="font-size: 9px; padding: 2px 4px;">
                                                            {{ req.reimbursements[0].statusSlug === 'PAID' ? 'Reembolsado' : 'Pendiente Pago' }}
                                                        </span>
                                                    </div>
                                                }
                                            </td>
                                            <td class="text-center align-middle">
                                                {{ req.createdAt | date: 'dd/MM/yyyy' }}
                                            </td>
                                            <td class="text-end align-middle">
                                                <span class="badge border" [ngClass]="req.statusObj?.style">
                                                     {{ req.statusObj?.name }}
                                                </span>
                                            </td>
                                            <td class="text-end align-middle">
                                                @if (req.processSlug === 'ACCIDENT' || req.processSlug === 'ACCIDENT_THIRD_PARTY' || req.processSlug === 'TOTAL_LOSS') {
                                                    <button class="btn btn-outline-primary btn-xs" (click)="viewClaimFromRequest(req)" ngbTooltip="Ver Siniestro" placement="top">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                }
                                                @if (req.processSlug === 'BENEFITS' || req.processSlug === 'BENEFIT') {
                                                    <button class="btn btn-outline-primary btn-xs" (click)="viewBenefitFromRequest(req)" ngbTooltip="Ver Beneficio" placement="top">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                }
                                                @if (req.processSlug === 'MEMBERSHIP_NEW') {
                                                    <button class="btn btn-outline-primary btn-xs" (click)="viewMembershipFromRequest(req)" ngbTooltip="Ver Solicitud" placement="top">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                }
                                                @if (req.processSlug === 'TRANSFER') {
                                                    <button class="btn btn-outline-primary btn-xs" (click)="viewTransferFromRequest(req)" ngbTooltip="Ver Transferencia" placement="top">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                }
                                                @if (bpmService.isUnsubscribeProcess(req.processSlug)) {
                                                    <button class="btn btn-outline-primary btn-xs me-1" (click)="viewUnsubscribeFromRequest(req)" ngbTooltip="Ver Solicitud de Baja" placement="top">
                                                        <i class="fas fa-eye"></i>
                                                    </button>
                                                    @if (req.statusSlug === 'DRAFT' || req.statusSlug === 'PENDING') {
                                                        <button class="btn btn-outline-danger btn-xs" (click)="deleteUnsubscribeRequest(req)" ngbTooltip="Cancelar Solicitud" placement="top">
                                                            <i class="fas fa-trash"></i>
                                                        </button>
                                                    }
                                                }
                                            </td>
                                        </tr>
                                        }
                                        }@else {
                                        <tr>
                                            <td colspan="4" class="text-center">No hay solicitudes recientes</td>
                                        </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
</div>
}


<!-- Modal Editar Vehículo (BPM) -->
<ng-template #vehicleModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title">
            {{ vehicleEditMode === 'quick' ? 'Edición rápida de vehículo' : 'Solicitud de actualización de vehículo' }}
        </h4>
    </div>
    <div class="modal-body">
        @if (vehicleEditMode === 'quick') {
            <p class="small text-muted mb-3">
                Los datos sensibles quedan bloqueados. Al enviar se crea una solicitud y el socio confirma por correo.
            </p>
        } @else {
            <p class="small text-muted mb-3">
                Al enviar se crea una solicitud de revisión (BPM). Los cambios se aplican solo al aprobar.
            </p>
        }
        <app-vehicle-form [vehicleForm]="vehicleForm" (formChange)="onVehicleSubmit($event)" [isReadOnly]="false"
            [mode]="formMode.EDIT" [editMode]="vehicleEditMode">
        </app-vehicle-form>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.dismiss('Close click')">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="submitVehicleForm()">Enviar</button>
    </div>
</ng-template>



@if(tabSelected==2 && documentsData && ((partyDocumentsData?.categories?.length || 0) > 0 || (vehicleDocumentsData?.categories?.length || 0) > 0)){
    <div class="panel">
        <div class="panel-body p-4">
            <h5 class="fw-bold text-dark mb-3"><i class="fas fa-id-card text-primary me-2"></i>Documentos del Socio</h5>
            <app-party-document [documents]="partyDocumentsData" [mode]="mode"
                (onDocumentUpdate)="refreshDocuments()"
                (onViewImage)="openGlobalViewer($event)">
            </app-party-document>
        </div>
    </div>
    <div class="panel mt-3">
        <div class="panel-body p-4">
            <h5 class="fw-bold text-dark mb-3"><i class="fas fa-car text-primary me-2"></i>Documentos por Vehículo</h5>
            <app-vehicle-document
                [vehicles]="vehicleData || []"
                [documents]="vehicleDocumentsData"
                [mode]="mode"
                (onDocumentUpdate)="refreshDocuments()"
                (onViewImage)="openGlobalViewer($event)">
            </app-vehicle-document>
        </div>
    </div>

    <!-- Visor de Imágenes Global en pantalla completa -->
    <app-viewer *ngIf="isViewerOpen" 
       [items]="viewerItems" 
       [activeId]="activeViewerId" 
       (onSelect)="activeViewerId = $event"
       (close)="isViewerOpen = false">
    </app-viewer>
}
}
@else {
  <app-add-claim 
      [partyInput]="data()" 
      [vehiclesInput]="vehicleHistoryData" 
      [claimUuidInput]="selectedClaimUuid()"
      (editorTitleChange)="onEditorTitle($event)"
      (headerEditorActionChange)="onHeaderEditorAction($event)"
      (onClose)="closeAddClaim()" 
      (claimAdded)="onClaimAdded()">
  </app-add-claim>
}

